import { InternalTagType } from '../types/InternalTag'
import { internalApiserverApi } from './internal-apiserver'

export type InternalGameScreenshot = {
  id: string
  url: string
  gameId: string
  gameVersion?: string | null
  markets?: string[] | null
  // Feature legacy id → choice weight id.
  features?: Record<string, number> | null
  versionReleaseDate?: number | null
  // Pairs with `markets` by position.
  analysisIds?: string[] | null
  conceptIds?: string[] | null
  commentId?: string | null
  commentPublished?: boolean | null
}

export type InternalFeatureTag = {
  id: string
  name: string
  type: string
  active?: boolean
  order?: number
  // Feature legacy ids.
  targets?: number[] | null
}

export type InternalFeatureMapFeature = {
  id: string
  legacyId: number
  name: string
  choices?: { weightId: number; choice: string }[] | null
  categoryId?: string
  active?: boolean
  stores?: string[] | null
  markets?: string[] | null
}

const screenshotLinksApi = internalApiserverApi.injectEndpoints({
  endpoints: (builder) => ({
    // Tagged by screenshot, as the concept and comment writes invalidate the screenshots they change.
    getInternalGameScreenshots: builder.query<InternalGameScreenshot[], string>({
      query: (gameId) => `screenshots/list/${gameId}`,
      providesTags: (result) => (result ?? []).map(({ id }) => ({ type: 'internalImplementationScreenshots', id })),
    }),
    getInternalFeatureTags: builder.query<InternalFeatureTag[], void>({
      query: () => ({ url: 'i/tags/list', params: { type: InternalTagType.Feature } }),
      providesTags: [{ type: 'internalTags', id: InternalTagType.Feature }],
    }),
    // Every feature, not only one market's.
    getInternalFeatureMapAllMarkets: builder.query<Record<string, InternalFeatureMapFeature>, void>({
      query: () => 'features/map/',
      providesTags: ['internalFeatures'],
    }),
  }),
})

export const { useGetInternalGameScreenshotsQuery, useGetInternalFeatureTagsQuery, useGetInternalFeatureMapAllMarketsQuery } = screenshotLinksApi
